<template>
  <div class="meal_detail">
    <div class="image" :style="'background-image: url('+order.meal.url+');'"></div>
    <div class="meal">
      <div class="details">
        <div class="title">{{order.meal.title}}</div>
        <div class="desc">{{order.meal.desc}}</div>
        <div class="ordered">
          <p>You ordered: </p>
          <p>{{ cleanDate(order.ts.toDate()) }}</p>
        </div>
        <div class="status">
          <p>Status:</p>
          <p>{{order.status}} <span v-if="order.status=='Picked up'">{{cleanDate(order.pickedup.toDate())}}</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fb_db } from '../firebase';
import { format } from 'date-fns';

export default {
  name: 'MealOrdered',
  async mounted () {
    //await this.getMeal();
    //this.loading = false;
  },
  methods: {
    cleanDate(date) {
      return format(date, 'HH:mm eee M/d');
    },
    async getMeal() {
      const doc = await fb_db.collection('orders').doc(this.meal.id).get();
      if (!doc.exists) {
        console.log('No such document!');
      } else {
        this.order = doc.data();
        this.order.id = doc.id;
        await fb_db.collection('meals').doc(this.order.meal).get()
        .then((res)=>{
          this.order.meal = res.data();
          this.order.meal.id = res.id;
        })
      }
    },
  },
  computed: {
    mealType() {
      return this.$route.name.toLowerCase()
    },
    order() {
      return this.$store.state.orders[this.mealType];
    },
  },    
}
</script>

<style lang="scss" scoped>
@import '@/assets/theme.scss';

.meal_detail {
  width: 100%;
  background: $white;
  //border-radius: 25px 0px 0px 0px;
  color: $text;


  .image {
    width: 100%;
    height: 30vh;
    //border-radius: 25px 0px 0px 0px;
    background-color: $primary;
    margin-right: 15px;
    background-size: cover;
  }

  .meal {
    text-align: left;
    padding: 15px 15px;
    background: $white;
    border-radius: 25px 0px 0px 0px;
    

    .title {
      font-size: 22px;
      margin-bottom: 5px;
    }

    .desc {
      font-size: 12px;
    }

    .action {
      display: flex;      
      height: 100%;
      justify-content: space-evenly;
      align-items: flex-end;

      .each {
        width: 80px;
        height: 50px;
        text-align: center;
        line-height: 40px;
      }
    }

    .status, .ordered {
      text-align: center;

      p:nth-child(1) {
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
      }

      p:nth-child(2) {
        font-size: 18px;
        font-weight: 600;
      }
    }
  }

}
</style>